import { createReducer } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { RecruitmentApplicationSchema, RecruitmentApplicationsSchema } from 'redux/schemas/api/mentoring-program-recruitment-applications';
import { getMentoringProgramRecruitmentApplications } from 'redux/actions/mentoring-program-recruitments';
import { RootState } from 'redux/schemas';
import { mergeWith } from 'lodash';
import { replaceArrays } from 'shared/lodash-utils';
import { initialRootState } from '.';


export default createReducer(initialRootState, (builder) => {
  builder
    .addCase(getMentoringProgramRecruitmentApplications.fulfilled, (state: RootState, action) => {
      const normalized = normalize(action.payload, RecruitmentApplicationsSchema);

      // TODO: do we want to do ⌄this?? I don't think so, but we need to handle that case...
      // Replace (not merge) so applications from a previously-visited program don't
      // accumulate alongside applications from the current program.
      state.models.mentorshipProgramRecruitmentApplications = normalized.entities.mentorshipProgramRecruitmentApplications ?? {};
    });
});
